import { PublicContentShareStatusResponse, ShareStatus } from "@authory-packages/core";
import { ProfileAccessGate } from "../../../../pages-components/ProfileAccessGate/ProfileAccessGate";
import {
    getServerSidePropsWithContentItem,
    V3ContentItemPublicPageLayoutContainer
} from "../../../../pagelayouts/content-details/ContentDetailsPublicPageLayoutContainer";

export default function ContentItemProfilePublicPage({
    profileShareStatus
}: {
    profileShareStatus: ShareStatus;
    contentItemShareStatus: PublicContentShareStatusResponse;
}) {
    return (
        <ProfileAccessGate profileShareStatus={profileShareStatus}>
            <V3ContentItemPublicPageLayoutContainer
                profileShareStatus={profileShareStatus}
                isStandaloneCollectionView={false}
                isStandaloneContentItemView={false}
                useProfileSmartShareEndpoint={false}
                useArticleSmartShareEndpoint={false}
            />
        </ProfileAccessGate>
    );
}

export const getServerSideProps = getServerSidePropsWithContentItem(false, true, false);
